import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-padditional',
    templateUrl: './padditional.component.html',
    styleUrls: ['./padditional.component.scss'],
})
export class PAdditionalComponent {
    @Input() cssClass;
    @Input() form: UntypedFormGroup;

    tooltip_position = 'above';
}
